<template>
  <div class="screen-admin-page screen-admin-usaga-report lead-info">
    <div>
      <div class="toolbar">
        <div class="title">
          <h1>Campaign Leads</h1>
        </div>
      </div>
    </div>
    <rz-request-state :state="state" />
    <div
      class="usage-report admin-screen-content"
      v-if="state.status.isLoaded"
    >
      <div class="table-block">
        <div class="item-list-row item-list">
          <CampaignInfoTable
            :title="values.title"
            :leadInfo="leadInfo.leads"
            @update-lead="fetchData({ page: leadInfo.pagination_params.current_page })"
          />
        </div>
        <div
          class="filter-pagination"
        >
          <div
            class="arrow left"
            :class="[leadInfo.pagination_params.current_page !== 1 ? null : 'disable']"
            @click="prevPage()"
          ></div>
          <div class="page-number">{{leadInfo.pagination_params.current_page}}</div>
          <div
            class="arrow right"
            :class="[leadInfo.pagination_params.current_page
            !== leadInfo.pagination_params.total_pages ? null : 'disable']"
            @click="nextPage()"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ref,
  watch,
  reactive,
  onMounted,
} from 'vue';
import { RequestState, RequestStateStatus } from '@/api/core';
import {
  ProjectList,
} from '@/store/modules/admin';
import CampaignInfoTable from '@/components/admin/CampaignInfoTable.vue';

export default {
  components: {
    CampaignInfoTable,
  },
  setup() {
    const state = ref(new RequestState());
    const leadInfo = ref({});
    const pageNumbers = ref([]);
    const pageLimit = 20;
    const title = ref('Campaign Info');

    const values = reactive({});

    const fetchData = (val) => {
      state.value.status = RequestStateStatus.Loading;
      const params = val ?? {
        page: 1,
      };
      return ProjectList.fetchCampaignLeadsInfo(params).then((resp) => {
        leadInfo.value = resp;
        state.value.status = RequestStateStatus.Loaded;
      }).catch((err) => {
        state.value.ref = err;
        state.value.status = RequestStateStatus.Error;
      });
    };

    const prevPage = () => {
      if (leadInfo.value.pagination_params.current_page === 1) {
        return;
      }
      const pageNum = leadInfo.value.pagination_params.current_page - 1;
      const params = {
        page: pageNum,
      };
      fetchData(params);
    };
    const nextPage = () => {
      if (leadInfo.value.pagination_params.current_page === leadInfo.value.pagination_params.total_pages) {
        return;
      }
      const pageNum = leadInfo.value.pagination_params.current_page + 1;
      const params = {
        page: pageNum,
      };
      fetchData(params);
    };

    onMounted(() => {
      fetchData();
    });

    watch(() => values && values.show_active, () => {
      fetchData();
    });

    return {
      leadInfo,
      state,
      title,
      values,
      pageNumbers,
      prevPage,
      nextPage,
      pageLimit,
    };
  },
};
</script>
<style lang="scss">
.lead-info {
  .filter-pagination {
    display: flex;
    justify-content: end;
    padding: 0 size(20);
    margin-bottom: size(50);
    .arrow {
      border-radius: size(5);
      border: size(1) solid var(--global--primary--Color);
      cursor: pointer;
      display: inline-block;
      &:after {
        content: '';
        border: solid var(--global--white--Color);
        border-width: 0 size(2) size(2) 0;
        display: inline-block;
        padding: size(3);
        vertical-align: middle;
      }
      &.left {
        padding: size(10) size(12) size(10) size(14);
        &:after {
          transform: rotate(135deg);
          -webkit-transform: rotate(135deg);
        }
      }
      &.right {
        padding: size(10) size(14) size(10) size(12);
        &:after {
          transform: rotate(-45deg);
          -webkit-transform: rotate(-45deg);
        }
      }
      &:hover {
        @include jump-up-animation;
      }
      &.disable {
        border: size(1) solid var(--global--gray--Color);
        cursor: not-allowed;
        &:after {
          border: solid var(--global--gray--Color);
          border-width: 0 size(2) size(2) 0;
        }
        &:hover {
          animation: none;
        }
      }
      }
    .page-number {
      margin: auto size(20);
    }
  }
  .table-block {
    display: inline-block;
    vertical-align: top;
    min-width: size(1000);
    .item-list {
      padding-top: 0;
      table {
        tr {
          &:hover {
            background: transparent;
          }
          td {
            &:first-child{
              cursor: default;
              button {
                cursor: default;
              }
            }
          }
        }
      }
    }
  }
}
</style>
